import { useTranslation } from 'react-i18next';

/**
 * The Activo/Inactivo word for a given state, from the shared
 * `common/userAvailability` namespace. Single owner of the state→label
 * mapping so aria-labels and the AvailabilityStatusPill can never disagree
 * (RET-1350).
 */
export function useAvailabilityStatusLabel(isActive: boolean): string {
  const { t } = useTranslation('common/userAvailability');
  return isActive ? t('statusActive') : t('statusInactive');
}
